import React, { CSSProperties, HTMLProps, ReactNode } from 'react';
import { FontStyleEnums, Typography, Colors } from '@oy/uicore';

export type AttributedTextProps = {
  textStyle: FontStyleEnums;
  tag?: 'div' | 'span';
  color?: Colors;
  children?: ReactNode;
} & HTMLProps<HTMLDivElement | HTMLSpanElement>;

function mapPropsToTextStyle(props: AttributedTextProps): CSSProperties {
  const textStyle = Typography[props.textStyle];
  const style: CSSProperties = {
    color: props.color,
    fontSize: textStyle.fontSize,
    fontWeight: textStyle.fontWeight ?? 'normal',
    letterSpacing: textStyle.letterSpacing ?? 0,
  };

  return style;
}

function AttributedText({
  color = Colors.BLACK100,
  tag,
  children,
  textStyle,
  ...props
}: AttributedTextProps) {
  const style = {
    ...(props.style || {}),
    ...mapPropsToTextStyle({ textStyle, color, ...props }),
  };
  const processedText = () => {
    let tempText = String(props.value);

    tempText?.match(/\*(.*?)\*/g)?.forEach(value => {
      tempText = tempText?.replace(value, `<b>${value}</b>`);
    });
    tempText = tempText?.replace(/\*/g, '');

    return tempText;
  };

  return (
    <div
      style={style}
      // TODO: Find another workaround dont use dangerouslySetInnerHTML
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: processedText() ?? '',
      }}
    />
  );
}

AttributedText.Style = FontStyleEnums;

export default AttributedText;
